import styled from 'styled-components';

const StyledSection = styled.section`
  margin-bottom: 1.25rem;
`;

const StyledSectionLabel = styled.h4`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0 0 0.625rem;
`;

const StyledMuted = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textMuted};
  font-weight: 300;
`;

const StyledEdgeCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderMuted};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 0.5rem;
  margin-bottom: 0.5rem;
`;

const StyledEdgeFrom = styled.div`
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 0.375rem;
`;

const StyledRow = styled.div`
  margin-bottom: 0.375rem;
`;

const StyledMutedLabel = styled.label`
  display: block;
  margin-bottom: 0.25rem;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const StyledInlineLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 13px;
  margin-bottom: 0.375rem;
`;

const StyledSelect = styled.select`
  width: 100%;
`;

const StyledRemoveButton = styled.button`
  color: ${({ theme }) => theme.colors.dangerText};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  padding: 0.15rem 0.5rem;
`;

const StyledAddWrapper = styled.div`
  margin-top: 0.5rem;
`;

export default {
  StyledSection,
  StyledSectionLabel,
  StyledMuted,
  StyledEdgeCard,
  StyledEdgeFrom,
  StyledRow,
  StyledMutedLabel,
  StyledInlineLabel,
  StyledSelect,
  StyledRemoveButton,
  StyledAddWrapper,
};
